<template>
  <div class="responsive-breakpoints-debug-ui">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'responsive-breakpoints-debug-ui',
  data () {
    return {
      text: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.responsive-breakpoints-debug-ui {
  position: fixed;
  bottom: 0;
  background: black;
  color: white;
  padding: 5px;
  font-size: 12px;
  margin: auto;
}
</style>
